import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

import { IPerkValue } from "@faire/retailer/views/faire-direct/sections/PerksSection/__internal__/PerkValues";

interface IProps {
  value: IPerkValue;
  index: number;
}
export const Perk: React.FC<IProps> = ({ value, index }) => {
  const { isMobile } = useViewport();
  return (
    <React.Fragment key={index}>
      {isMobile && index !== 0 ? <Spacer height="5x" /> : null}
      <ValueContainer data-test-id={`perk-title-${index}`}>
        <Typography variant="displaySSerifRegular" align="center">
          {value.head}
        </Typography>
        <Spacer height="2x" />
        <Typography align="center">{value.body}</Typography>
      </ValueContainer>
    </React.Fragment>
  );
};
const ValueContainer = styled(Column)`
  padding: ${getSpacing(0, "3x")};
  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: 348px;
    width: 33%;
  }
`;
